import {
  pipe,
  prop,
  set,
  lensProp,
  ifElse,
  equals,
  identity,
  over,
  lensPath,
  reduce,
  append,
  sum,
  view,
  map,
  hasPath,
  always,
  uniq,
  chain,
  innerJoin,
  eqProps,
  filter,
  path,
  pathOr,
  not,
  find,
  __,
  converge,
  propEq,
} from 'ramda'
import {
  mutateQuantitiesWithNormalization,
  summedQuantitiesPerClassificationPerProductGroupProductKey,
  quantitiesPerClassificationGroupedByProductGroupProductKey,
} from './SegmentedQuantityCalculations.js'
import getNormalizedQuantity from './getNormalizedQuantity.js'
import { propIsFalsy, sumProp, pathMap, makeObj } from '@/vue/util/briqRamdaExt.js'

export const extractSegments = ifElse(
  Array.isArray,
  chain(pipe(prop('QuantitiesPerSegment'), map(prop('SegmentCode')))),
  always([]),
)

export const sumQuantities = pipe(pathOr([], [0, 'QuantitiesPerSegment']), sumProp('Quantity'))

export const mutateAndGetQuantitiesPerClassificationGroupedByProductGroupProductKey = logError => bookingDeal => {
  const x = {
    bookingDeal,
    getNormalizedQuantity: getNormalizedQuantity(logError),
  }
  // mutateQuantitiesWithNormalization(x) // !! this causes double normalization in quantitiesPerClassificationGroupedByProductGroupProductKey and intersectedQuantitiesPerClassification
  const o = quantitiesPerClassificationGroupedByProductGroupProductKey(x)
  return o
}

// todo: refactor this incomprehensible beast!
export const totalQuantitiesPerClassification = (
  bookingDeal,
  quantitiesPerClassificationGroupedByProductGroupProductKey,
  intersectedQuantitiesPerClassification,
  quantitiesByProductGroupProductKey,
) => {
  const firstProductWithSegments = bookingDeal.products.find(p => !p.isSegmentless)
  if (!firstProductWithSegments) return []
  const summed = summedQuantitiesPerClassificationPerProductGroupProductKey({
    quantitiesPerClassificationGroupedByProductGroupProductKey,
    intersectedQuantitiesPerClassification,
    quantitiesByProductGroupProductKey,
  })
  const quantitiesPerClassification = Object.values(summed)[0]
  return quantitiesPerClassification
}

// quantitiesPerClassificationGroupedByProductGroupProductKey
// { [pgpKey]: BookingProduct[] }

// intersectedQuantitiesPerClassification
// [{ ClassificationCode, QuantitiesPerSegment [{ Quantity, SegmentCode, SegmentName }] }]

// quantitiesByProductGroupProductKey
// { [pgpKey]: { [classificationCode: { [segment]: quantity }] } }
